// import $ from "jquery";
const jquery = require("jquery");
// Bootstrap JS and CSS
import "./vendor/bs_modules";
// import "./custom/videogif";
// import "/_assets/js/vendor/bs_modules";

import "flickity/dist/flickity.min.css";
import Flickity from "flickity";
import "flickity-imagesloaded";
// Bootstrap Popover
// import "./vendor/popover";

// Bootstrap Tooltip
// import "./vendor/tooltip";

import "../css/main.scss";

import { initTranslate } from "./custom/translate";
import initNav from "./custom/nav";

import { initSlideCart } from "./custom/slide-cart";

import initFileUploader from "./custom/file-uploader";

window.jQuery = window.$ = jquery;
window._atlas_ = window._atlas_ || { debug: false };

$(function () {
  // console.clear();
  initNav();
  initVideoGif();
  initCommunityCard();
  initFindRate();
  initTranslate();
  initGlobalListeners();
  initSlideCart();
  initFileUploader('UploadDocumentForm');

  $(".js-search-toggle").click(function (e) {
    e.preventDefault();
    $(".js-search-bar").toggle();
  });

  $("#mobileMenu")
    .on("show.bs.collapse", function (e) {
      toggleLockScroll(e);
    })
    .on("shown.bs.collapse, hide.bs.collapse", function (e) {
      toggleLockScroll(e);
    });
});

function initFindRate() {
  $(".js-find-rate").click(function (e) {
    e.preventDefault();
    var $postcode = $("#js-find-postcode"),
      postcode = $postcode.val(),
      url = $("#js-find-url").val();
    if (postcode && postcode.length === 4) {
      // window.open(url + "#" + postcode);
      window.open(url + "?postcode=" + postcode);
    } else {
      alert("Please add a valid postcode");
    }
  });
}

function fixPostcodeDigits(val) {
  if (val.length < 1) {
    return "";
  } else if (val.length < 4) {
    // 200 => 0200
    if (val.length < 3) {
      // 20 => 2000
      return fixPostcodeDigits(val + 0 + 0);
    }
    return fixPostcodeDigits(0 + val);
  } else {
    return val;
  }
}

function initCommunityCard() {
  var $step1 = $("[data-connect-step='1']"),
    $step2 = $("[data-connect-step='2']");

  $(".js-postcode").on("keydown", function (e) {
    if (e.key === "Enter") {
      // fix postocde
      $(".js-postcode").val(fixPostcodeDigits(e.target.value));
      // trigger submit of input with enter
      $(this).next(".js-connect").trigger("click");
    }
  });

  $(".js-postcode").on("blur change", function (e) {
    // sync all field on the page
    $(".js-postcode").val(fixPostcodeDigits(e.target.value));
    // remove error
    $(".js-connect-error").hide();
  });

  $(".js-connect").click(function (e) {
    e.preventDefault();
    // hide errors
    $(".js-connect-error").hide();
    $("[data-connect-step='error']").hide();

    var $input = $(this).prev(".js-postcode");

    var postcode = $input.val();
    console.log("====");
    console.log(postcode);
    console.log("====");

    if (postcode && postcode.length === 4 && postcode >= 200) {
      $("body").addClass("screenlock");

      // 1 - lookup
      // might need an event for the BE

      // dispatch(document, "postcode_lookup", { postcode: postcode });
      var event = new CustomEvent("postcode_lookup", {
        detail: {
          postcode: postcode,
        },
      });
      document.dispatchEvent(event);
      // go step 2
      // might need to post the height of the card
      if ($step1.height() > $step2.height()) {
        $step2.height($step1.height());
      }
      $step1.hide();
      $step2.show();
    } else {
      // alert("Please add a valid postcode");
      $(".js-connect-error").show();
    }
  });

  $(".js-connect-close").click(function (e) {
    e.preventDefault();
    resetPostcode();
  });

  // $(".js-connect-go").click(function (e) {
  //   e.preventDefault();
  //   location.href = $("#js-connect-go").val();
  // });
  $(".js-connect-go").click(function (e) {
    e.preventDefault();
    var _location = $(this).prev(".js-community-go").val();
    if (_location) {
      location.href = _location;
    }
  });

  // $(document).on("postcode_lookup", function (e) {
  //   console.log("====");
  //   console.log(e);
  //   console.log("====");
  // });
}

function resetPostcode(params) {
  var $step1 = $("[data-connect-step='1']"),
    $step2 = $("[data-connect-step='2']");
  $step2.hide();
  $step1.show();
  $("[data-connect-step='error']").hide();
  $("body").removeClass("screenlock");
}

function initVideoGif(e) {
  if ($("#videogif").length) {
    $("#videogif").get(0).playbackRate = 2;
  }
}

function toggleLockScroll(e) {
  if (e.target.id === "mobileMenu") {
    // console.log("lock", e.target.id);
    $("body").toggleClass("modal-open");
  }
}

function initGlobalListeners() {
  handleEscKey();
}

function handleEscKey(params) {
  $(window).escape(function (e) {
    // console.log("====");
    // console.log("esc");
    // console.log("====");
    resetPostcode();
  });
}

$.fn.escape = function (callback) {
  return this.each(function () {
    $(document).on("keydown", this, function (e) {
      var keycode =
        typeof e.keyCode != "undefined" && e.keyCode ? e.keyCode : e.which;
      if (keycode === 27) {
        callback.call(this, e);
      }
    });
  });
};

// var dispatch = function (elem, eventName, options) {
//   // events polyfill
//   //Needed for IE Support: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent#Browser_Compatibility
//   //https://stackoverflow.com/a/49071358/79677
//   var event;
//   if (typeof Event === "function") {
//     event = new Event(eventName, options);
//   } else {
//     event = document.createEvent("Event", options);
//     event.initEvent(eventName, true, true);
//   }
//   elem.dispatchEvent(event);

//   return event;
// };

// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function () {
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();


//   -----------------------------------------------------------
$(document).ready(function() {
  $(".header-main .overlay-black").hover(function() {
      $('.menu-overlay').addClass("is-active");
  }, function() {
      $('.menu-overlay').removeClass("is-active");
  });
});

// -------------------- drop-down arrow js  ----------------===============
$(document).ready(function(){
  $(".angle-top-arrow").click(function() {
      $(this).closest('li').find('.drop-down-text').toggleClass("angle");
  });
});

// -------  menu js ---------------========================
$(document).ready(function(){
  $(".mobile-menu-icon").click(function() {
      $('body').toggleClass("menu-open");
  });
});

$(document).ready(function(){
  $(".main-menu .overlay-black").hover(function() {
      $('body').toggleClass("overflow");
  });
});